import Vue from 'vue';
//@ts-ignore
import NewsletterExtended from '../Newsletter/NewsletterExtended.vue';
Vue.config.productionTip = false;
var initializeNewsletterExtended = function () {
    //@ts-ignore
    var newsletterExtendedContainer = document.querySelectorAll('.newsletterExtendedContainer');
    //@ts-ignore
    newsletterExtendedContainer.forEach(function (item) {
        new Vue({
            render: function (h) { return h(NewsletterExtended, {
                props: {
                    //@ts-ignore
                    servicenewsletterid: item.dataset.servicenewsletterid,
                    //@ts-ignore
                    reference: item.dataset.reference,
                    //@ts-ignore
                    headline: item.dataset.headline,
                    //@ts-ignore
                    text1: item.dataset.text1,
                    //@ts-ignore
                    button: item.dataset.button,
                    //@ts-ignore
                    text2: item.dataset.text2,
                    //@ts-ignore
                    imageUrl: item.dataset.imageurl,
                    //@ts-ignore
                    webpImageUrl: item.dataset.webpimageurl,
                    //@ts-ignore
                    imageAltText: item.dataset.imagealttext,
                    //@ts-ignore
                    imageClass: item.dataset.imageclass,
                    //@ts-ignore
                    sizeClass: item.dataset.sizeclass,
                    //@ts-ignore
                    promoId: typeof item.dataset.promoid !== 'undefined' ? item.dataset.promoid : '',
                    //@ts-ignore
                    promotion: typeof item.dataset.promotion !== 'undefined' ? item.dataset.promotion : '',
                    //@ts-ignore
                    name: typeof item.dataset.name !== 'undefined' && item.dataset.plz == "true",
                    //@ts-ignore
                    plz: typeof item.dataset.plz !== 'undefined' && item.dataset.plz == "true"
                }
            }); },
        }).$mount(item);
    });
};
export default initializeNewsletterExtended;
